import { IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';

const SquareIconButton = styled(IconButton)(({ theme }) => ({
    backgroundColor: theme.palette.grey[9],
    color: theme.palette.grey[3],
    borderRadius: 4,
    marginRight: 16,
    padding: 12,
    '&.VL-SquareIconButton-Selected': {
        backgroundColor: theme.palette.grey[2],
        color: theme.palette.grey[10]
    }
}));

export default SquareIconButton;
